import { useCallback, useEffect, useState } from "react";
import { CONSOLE_THEME_KEY } from "@/lib/storage";

type ConsoleTheme = "light" | "dark";

function readInitialTheme(): ConsoleTheme {
  try {
    return window.localStorage.getItem(CONSOLE_THEME_KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function useConsoleTheme() {
  const [theme, setTheme] = useState<ConsoleTheme>("light");

  useEffect(() => {
    const initial = readInitialTheme();
    setTheme(initial);
    document.body.setAttribute("data-console-page", "");
    document.body.setAttribute("data-console-theme", initial);
    return () => {
      document.body.removeAttribute("data-console-page");
      document.body.removeAttribute("data-console-theme");
    };
  }, []);

  const toggle = useCallback(() => {
    setTheme((prev) => {
      const next: ConsoleTheme = prev === "dark" ? "light" : "dark";
      document.body.setAttribute("data-console-theme", next);
      try {
        window.localStorage.setItem(CONSOLE_THEME_KEY, next);
      } catch {
        // ignore
      }
      return next;
    });
  }, []);

  return { theme, toggle };
}
